import $ from 'jquery';

let list;
let listItems;

let $filterForm;
let $filterFormInput;
let $searchListItems;

const filterHiddenClass = 'list-item-hidden';
const noResultsClass = 'tips-no-results';

// form search
function filterByString(string){
    list.removeClass(noResultsClass);
    const queryClean = string.toLowerCase();
    let totalCount = 0;

    $searchListItems.each(function (i, el) {

        const $el = $(el);
        const content = $el.html().toLowerCase();
        if (content.indexOf(queryClean) !== -1) {
            // Show
            $el.removeClass(filterHiddenClass);
            totalCount++;

        } else {
            // hide
            $el.addClass(filterHiddenClass);
        }
    });

    if (totalCount < 1){
        list.addClass(noResultsClass);
    }
}

function clearFilter(){
    list.removeClass(noResultsClass);
    $('.' + filterHiddenClass).removeClass(filterHiddenClass);
}

function searchSubnmitHandler() {
    const val = $filterFormInput.val();
    if (val !== '' && val.length > 2) {
        filterByString(val);
        console.log('long enough'); // eslint-disable-line no-console
    } else {
        console.log('shorts'); // eslint-disable-line no-console
        clearFilter();
    }
}

function addFormFilterHandlers() {
    $filterForm.on('submit', function (e) {
        e.preventDefault();
        searchSubnmitHandler();
    });
    $filterFormInput.on('keyup', searchSubnmitHandler);
}

function scrollToOpened(item) {
    const $item = item ? $(item) : $('.tipstricks-list-item.open');
    $item.find('.tipstricks-list-item-content').show();
    const offset = $item.offset();

    $('html, body').animate({
        scrollTop: offset.top - 10,
        scrollLeft: offset.left
    });
}

function hideItem(item){
    const $item = $(item);
    $item.find('.tipstricks-list-item-content').hide();
}

function addToggle(item){
    const $item = $(item);
    $item.find('.tipstricks-list-item-header').on('click', function(){
        const content = $item.find('.tipstricks-list-item-content');
        $item.toggleClass('open');
        content.slideToggle();
    });
}

function init(){
    list = $('.tipstricks-list');
    listItems = $('.tipstricks-list-item');

    $filterForm = $('.tipstricks-search-form form');
    $filterFormInput = $filterForm.find('[name="q"]');
    $searchListItems = $('.tipstricks-list-item');


    if (listItems.length < 1 || list.length < 1) return;

    listItems.each(function(){
        if (this.classList.contains('open')) {
            scrollToOpened(this);
        } else {
            hideItem(this);
        }
        addToggle(this);
    });

    addFormFilterHandlers();
}

export default {
    init: init,
    scrollToOpened: scrollToOpened
};
